import CssSelectorRequest from '@/@api/cssSelector'
import { ref, computed } from '@vue/composition-api'
// import store from '@/store'
// import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { debouncedWatch } from '@vueuse/core'

const selectors = ref([])

export default function useCssSelector() {
  // Use toast
  const toast = useToast()

  const refLinkListTable = ref(null)

  // const selectors = ref([])

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { label: 'Nombre', key: 'name', sortable: true },
    {
      label: 'Link',
      key: 'uri',
      sortable: true,
      thStyle: { width: '100%' },
    },
    { label: 'Idiomas', key: 'langs', sortable: true },
    { label: 'Países', key: 'countries', sortable: true },
    { label: 'Activo', key: 'status', sortable: true },
    { label: 'Acciones', key: 'actions' },
  ]
  const perPage = ref(10)
  const totalLinks = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refLinkListTable.value ? refLinkListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalLinks.value,
    }
  })

  const refetchData = () => {
    refLinkListTable.value.refresh()
  }

  debouncedWatch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  }, { debounce: 400 })

  const fetchLinks = (ctx, callback) => {
    CssSelectorRequest.list({
      params: {
        q: searchQuery.value,
        paginate: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      },
    })
      .then(response => {
        console.log(response.data.data)
        const { data, total } = response.data.data

        callback(data.map(selector => ({ ...selector, loading: false })))
        totalLinks.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching selectors list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // async function fetchLinksSelector(isMemo = false) {
  //   if (isMemo && selectors.value.length) {
  //     return Promise.resolve(selectors.value)
  //   }

  //   try {
  //     const { data } = await CssSelectorRequest.select()
  //     console.log(data)

  //     const list = data.data.map(selector => ({
  //       id: selector.id,
  //       value: selector.iso?.toUpperCase() || selector.id,
  //       label: selector.name,
  //     }))

  //     selectors.value = list

  //     return list
  //   } catch (error) {
  //     throw new Error(error)
  //   }
  // }

  async function selectorShow(id) {
    try {
      const { data } = await CssSelectorRequest.show(id)
      console.log(data)
      return Array.isArray(data.data) ? data.data[0] : data.data
    } catch (error) {
      throw new Error(error)
    }
  }

  async function selectorStore(body) {
    try {
      const { data } = await CssSelectorRequest.store(body)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async function selectorUpdate(id, body) {
    try {
      const { data } = await CssSelectorRequest.update(id, body)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async function selectorDelete(id) {
    try {
      const { data } = await CssSelectorRequest.destroy(id)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  // fetchLinksSelector(true).then(list => {
  //   selectors.value = list
  // })

  // const resolveIsoLink = iso => {
  //   if (!iso) return ''

  //   const dic = selectors.value.reduce((acc, selector) => {
  //     acc[selector.value] = selector.label

  //     return acc
  //   }, {})

  //   return dic[iso] ?? iso
  // }

  return {
    selectors,
    fetchLinks,
    // fetchLinksSelector,
    tableColumns,
    perPage,
    currentPage,
    totalLinks,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refLinkListTable,

    // resolveIsoLink,

    refetchData,
    selectorShow,
    selectorStore,
    selectorUpdate,
    selectorDelete,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
